import React, { useEffect, useState } from 'react';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db, storage } from '../firebaseConfig';
import { useAuthState } from 'react-firebase-hooks/auth';
import Sidebar from './Sidebar';
import './Projects.css';

function SettingsPage() {
  const [user] = useAuthState(auth);
  const [userName, setUserName] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [footerHeight, setFooterHeight] = useState(54);
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [role, setRole] = useState('engineer');

  useEffect(() => {
    const fetchUserSettings = async () => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          if (data.name) setUserName(data.name);
          if (data.companyLogoUrl) setLogoUrl(data.companyLogoUrl);
          if (data.footerHeightPt) setFooterHeight(data.footerHeightPt);
          if (data.role) setRole(data.role);
        }
      }
    };
    fetchUserSettings();
  }, [user]);

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!user || !selectedFile) return;
    setUploading(true);
    try {
      const storageRef = ref(storage, `logos/${user.uid}/companyLogo.png`);
      await uploadBytes(storageRef, selectedFile);
      const downloadUrl = await getDownloadURL(storageRef);

      const userRef = doc(db, 'users', user.uid);
      await setDoc(
        userRef,
        {
          companyLogoUrl: downloadUrl,
          footerHeightPt: footerHeight,
        },
        { merge: true }
      );

      setLogoUrl(downloadUrl);
      setSelectedFile(null);
    } catch (err) {
      console.error('Upload failed:', err);
    } finally {
      setUploading(false);
    }
  };

  const handleHeightChange = async (e) => {
    const value = parseInt(e.target.value, 10);
    setFooterHeight(value);

    if (user) {
      try {
        await setDoc(
          doc(db, 'users', user.uid),
          { footerHeightPt: value },
          { merge: true }
        );
      } catch (err) {
        console.error('Error saving footer height:', err);
      }
    }
  };

  return (
    <div className="Project2Page">
      <header>Settings</header>

      <Sidebar role={role} />

      <div
        className="main-content"
        style={{
          color: 'black',
          marginLeft: '200px',         // matches sidebar
          padding: '2rem 2rem 2rem 50px',  // ⬅️ left padding = 50px
          maxWidth: '1000px'
        }}
      >

        {userName && (
          <h2 style={{ fontSize: '1.5rem', marginTop: '1rem' }}>
            Welcome {userName}
          </h2>
        )}

        <div style={{ marginTop: '2rem' }}>
          <h4>Upload Company Logo (for PDF Footer)</h4>

          {logoUrl && (
            <div style={{ marginTop: '1rem' }}>
              <img
                src={logoUrl}
                alt="Company Logo"
                style={{ height: '80px', borderRadius: '6px', marginBottom: '0.5rem' }}
              />
              <p style={{ fontSize: '0.9rem' }}>Current logo preview</p>
            </div>
          )}

          <input type="file" accept="image/*" onChange={handleFileChange} style={{ marginTop: '1rem' }} />
          <br />
          <button onClick={handleUpload} disabled={uploading || !selectedFile} style={{ marginTop: '1rem' }}>
            {uploading ? 'Uploading...' : 'Upload Logo'}
          </button>
        </div>

        <div style={{ marginTop: '2rem' }}>
          <label htmlFor="footerHeight" style={{ fontWeight: 'bold' }}>
            Footer Logo Height (in points):
          </label>
          <br />
          <input
            type="number"
            id="footerHeight"
            value={footerHeight}
            onChange={handleHeightChange}
            min={12}
            max={72}
            step={1}
            style={{ marginTop: '0.5rem', padding: '0.25rem', width: '80px' }}
          />
          <p style={{ fontSize: '0.85rem', marginTop: '0.25rem' }}>
            Recommended: 24 (smaller) or 54 (original)
          </p>
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;
